import { Backdrop as MuiBackdrop } from '@mui/material';
import { styled } from '@mui/system';

export const Backdrop = styled(MuiBackdrop)(({ theme }) => ({
  // @ts-ignore
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: '#FFFFFF99',
}));
